
(function () {
  function initDragScroll(container) {
    if (!container || container.dataset.dragInit) return;
    container.dataset.dragInit = 'true';

    var isDown = false, startX, scrollLeft;

    container.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return; // touch/pen use native scroll, untouched
      var style = getComputedStyle(container);
      if (style.overflowX !== 'auto' && style.overflowX !== 'scroll') return; // no-op on desktop
      isDown = true;
      container.classList.add('is-dragging');
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
    });

    ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (evt) {
      container.addEventListener(evt, function () {
        isDown = false;
        container.classList.remove('is-dragging');
      });
    });

    container.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - container.offsetLeft;
      var walk = (x - startX) * 1.2;
      container.scrollLeft = scrollLeft - walk;
    });

    container.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') container.scrollBy({ left: 200, behavior: 'smooth' });
      if (e.key === 'ArrowLeft') container.scrollBy({ left: -200, behavior: 'smooth' });
    });
  }

  function markAccessible(container) {
    function update() {
      if (container.scrollWidth > container.clientWidth + 4) {
        container.setAttribute('tabindex', '0');
        container.setAttribute('role', 'region');
        container.setAttribute('aria-label', 'Shop by category, scroll to see more');
      } else {
        container.removeAttribute('tabindex');
        container.removeAttribute('role');
        container.removeAttribute('aria-label');
      }
    }
    update();
    window.addEventListener('resize', update);
  }

  function setup() {
    document.querySelectorAll('.khushbu-category-list .m-mixed-layout__inner').forEach(function (el) {
      initDragScroll(el);
      markAccessible(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
